import request from '@/utils/request'

export interface AuditFinding {
  id: number
  auditRunId: string
  platform: 'ios' | 'android'
  userId: string | null
  userEmail: string | null
  sourceReference: string
  productId: string | null
  findingType: string
  severity: 'critical' | 'high' | 'medium' | 'low'
  expectedFeatures: string[] | null
  actualFeatures: string[] | null
  expectedExpires: string | null
  actualExpires: string | null
  storeStatus: string | null
  details: any
  resolvedAt: string | null
  resolutionNotes: string | null
  createdAt: string
}

export interface FindingsListParams {
  page?: number
  limit?: number
  auditRunId?: string
  platform?: string
  findingType?: string
  severity?: string
  userId?: string
  userEmail?: string
  unresolved?: boolean
}

export const runSubscriptionAudit = (body: { sinceDays?: number; platforms?: string[]; includePlatformApis?: boolean; maxSubs?: number }) =>
  request({ url: '/admin/subscription-audit/run', method: 'post', data: body })

export const listSubscriptionAuditFindings = (params: FindingsListParams) =>
  request({ url: '/admin/subscription-audit/findings', method: 'get', params })

export const getSubscriptionAuditSummary = () =>
  request({ url: '/admin/subscription-audit/summary', method: 'get' })

export const resolveSubscriptionAuditFinding = (findingId: number, notes: string) =>
  request({ url: `/admin/subscription-audit/findings/${findingId}/resolve`, method: 'post', data: { notes } })
